import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true so the httpOnly rw_token cookie is sent on every
// authenticated request. Same-origin in preview/production; the cookie is
// the ONLY carrier now — the legacy localStorage Bearer fallback has been
// retired to eliminate the XSS-token-theft attack surface.
const instance = axios.create({ baseURL: API, withCredentials: true });

instance.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 402) {
            // Trial ended / subscription required — bounce to pricing
            if (typeof window !== "undefined" && !window.location.pathname.startsWith("/pricing")
                && !window.location.pathname.startsWith("/payment")) {
                window.location.href = "/pricing";
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Fire-and-forget outbound-click tracker
export function trackClick(surface, target, variant) {
    try {
        instance.post("/analytics/click", { surface, target, variant }).catch(() => {});
    } catch { /* noop */ }
}

// Build the tutoring outbound URL with UTM attribution for GA.
// surface = where the click originated (landing, dashboard, pricing, navbar, bundle).
export function tutoringUrl(surface) {
    const params = new URLSearchParams({
        utm_source: "liftupreading",
        utm_medium: "web",
        utm_campaign: "cross-sell",
        utm_content: surface || "unknown",
    });
    return `https://www.liftupliteracy.com/?${params.toString()}`;
}

export default instance;
